module.exports = __webpack_public_path__ + "img/greydot.9803548b.svg";